import type { SearchTemplate } from '@atlassian/jira-jql-builder-basic-picker/src/common/types.tsx';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { messages, messageLookup } from './messages.tsx';

/**
 * Given a search template key, this function returns the i18n label to be displayed for the EMPTY keyword
 * @param searchTemplate field's search template, e.g. "components"
 * @param formatMessage react-intl's formatMessage function
 * @returns {string} i18n label for the EMPTY keyword, e.g. "No component"
 */
export const getEmptyLabel = (
	searchTemplate: SearchTemplate,
	formatMessage: FormatMessage,
): string => {
	const message = messageLookup[searchTemplate];
	if (message) return formatMessage(message);

	return formatMessage(messages.genericEmpty);
};
